<div class="container">

    <div class="main-section">
        <div class="main-container" #scrollContainer>
            <router-outlet (activate)="onActivate($event, scrollContainer)"></router-outlet>
        </div>
    </div>

</div>
<footer class="bg-primary">
    <div layout="row" layout-align="center center">
        <!-- 2022. Rhema for the Nations. All Rights Reserved -->
        <p layout-align="center center">Copyright &copy; {{currentYear}}. Marisree LLC. All Rights Reserved
        </p>
    </div>
</footer>

<div *ngIf="showSessionDialog" class="session-dialog-backdrop" role="dialog" aria-modal="true">
    <mat-card class="session-dialog">
        <h2>{{ sessionDetails.state === 'expired' ? 'Session expired' : 'Session expiring' }}</h2>

        <ng-container *ngIf="sessionDetails.state === 'warning'; else expiredMessage">
            <p>Your session will expire in:</p>
            <p class="session-countdown">{{ formattedSessionRemaining }}</p>
            <p>Extend your sign-in now to continue without interruption.</p>
        </ng-container>
        <ng-template #expiredMessage>
            <p>Your session has expired. Please sign in again to continue working.</p>
        </ng-template>

        <p *ngIf="sessionError" class="session-error">{{ sessionError }}</p>
        <div class="session-actions">
            <button mat-stroked-button color="warn" [disabled]="isExtendingSession" (click)="logoutSession()">
                Log out
            </button>
            <button mat-raised-button color="primary" [disabled]="isExtendingSession" (click)="extendSession()">
                {{ isExtendingSession ? 'Extending…' : 'Extend sign-in' }}
            </button>
        </div>
    </mat-card>
</div>
